import { isNonEmptyArray } from '../../utils/checks'
import { setLocalStorage, getLocalStorage } from '../../utils/localStorage'

export const updateFavoriteStorage = ({
  centerId
}: {
  centerId: number
}): number[] => {
  const favoriteCenters =
    (getLocalStorage('favoriteCenters') as number[] | null) || []

  if (!isNonEmptyArray(favoriteCenters)) {
    setLocalStorage('favoriteCenters', [centerId])
    return [centerId]
  }
  const existingCenter = getFavoriteCenterFromLocalStorage({
    centerId,
    favoriteCenters
  })

  if (existingCenter) {
    return removeFavoriteCenter({ centerId, favoriteCenters })
  }

  return saveFavoriteCenter({ centerId, favoriteCenters })
}

export const saveFavoriteCenter = ({
  centerId,
  favoriteCenters
}: {
  centerId: number
  favoriteCenters: number[] | []
}): number[] => {
  setLocalStorage('favoriteCenters', [...favoriteCenters, centerId])
  return [...favoriteCenters, centerId]
}

export const removeFavoriteCenter = ({
  centerId,
  favoriteCenters
}: {
  centerId: number
  favoriteCenters: number[] | []
}): number[] => {
  const modifiedFavoriteCenters = favoriteCenters.filter(
    (favoritecenterId) => favoritecenterId !== centerId
  )
  setLocalStorage('favoriteCenters', [...modifiedFavoriteCenters])
  return modifiedFavoriteCenters
}

export const getFavoriteCenterFromLocalStorage = ({
  centerId,
  favoriteCenters
}: {
  centerId: number
  favoriteCenters: string[] | []
}): number | null | undefined => {
  if (!isNonEmptyArray(favoriteCenters)) return null

  const favoriteCentersMap = favoriteCenters.map((id) => {
    return parseInt(id)
  })

  return favoriteCentersMap.find(
    (favoritecenterId) => favoritecenterId === centerId
  )
}

export const isFavorite = (centerId: number): boolean => {
  const favoriteCenters =
    (getLocalStorage('favoriteCenters') as string[] | null) || []
  return !!getFavoriteCenterFromLocalStorage({ centerId, favoriteCenters })
}

export const clearFavoriteStorage = (): void => {
  setLocalStorage('favoriteCenters', [])
}
